import { Typography, useMediaQuery, useTheme } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import React, { useContext } from "react"
import DarkButton from "~/components/Common/DarkButton"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import ClientContext from "~/contexts/Client"
import Box from "../../Common/Box"
import ApiKey from "../ApiKey"
import useStyles from "./styles"

const ApiKeys = () => {
  const classes = useStyles()
  const theme = useTheme()
  const { openDialog } = useContext(AppContext)
  const { client } = useContext(ClientContext)
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  const openAddKeysDialog = () => {
    let data = { client: client, action: "create" }
    openDialog("AddKeysToClientsDialog", data)
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="10px"
      >
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          <Typography
            variant="h3"
            color="primary"
            style={{ fontWeight: "700", marginRight: "8px" }}
          >
            API Keys
          </Typography>
        </Box>
        <PermissionsWrapper permissionGroup="admin">
          <DarkButton
            onClick={openAddKeysDialog}
            startIcon={
              <AddCircle
                fontSize="small"
                classes={{ root: classes.addCircle }}
              />
            }
          >
            New API Key
          </DarkButton>
        </PermissionsWrapper>
      </Box>
      <Box
        marginBottom="10px"
        maxHeight={smDown ? "100%" : "400px"}
        overflow="auto"
      >
        {client?.api_keys?.length > 0 &&
          client?.api_keys
            .sort((a, b) => {
              return new Date(b.updated) - new Date(a.updated)
            })
            .map((single, i) => {
              return <ApiKey apiKey={single} client={client} key={i} />
            })}
      </Box>
    </>
  )
}

export default ApiKeys
